import { ITEM_TYPE, playerTypes } from '../config/constants';
import h from '../helpers/common';
import channelsUtil from '../helpers/channelsUtil';
import user from '../helpers/user';
import { EVENT } from './MixpanelConstants';

export const getPaymentInAppMessageProperties = () => {
    const tierName = user.getUserInfo()?.tierConfig?.tierName;
    const userTierAtTime = { Free: 'Basic', Plus: 'Premium', Paid: 'Premium' }[tierName] || tierName || 'Basic';

    return {
        'Message Type': 'Payment Failed',
        'User Tier at Time': userTierAtTime,
    };
};
export const getMixpanelProviderProperties = (vodProvider) => {
    const providers = h.getProviders();
    let providerName = Object.keys(providers).reduce((result, item) => {
        if (item.toUpperCase() === vodProvider.toUpperCase()) result.push(providers[item].mixpanel);
        return result;
    }, []);
    providerName = providerName.toString();
    return {
        'Provider Name': providerName,
    };
};

export const getMixpanelItemTypeProperty = (item) => {
    const itemType = channelsUtil.isEarlier(item) ? 'Rewind' : channelsUtil.isNow(item) ? 'Live' : '';
    return {
        'Item Type': itemType,
    };
};

export const getMixpanelScreenLoadProperties = (screenProps) => {
    return screenProps.reduce(function (result, prop) {
        if (prop === 'Country') {
            result['Country'] = h.getLocation();
        }
        return result;
    }, {});
};
export const getMixpanelNavMenuProperties = (itemTitle) => {
    return {
        'Item Title': itemTitle,
    };
};
export const getMixpanelProfileList = (ProfileLists) => {
    const profileKeys = [
        'profileName',
        'parentalControl',
        'passwordProtected',
        'defaultAudioLang',
        'defaultSubTitleLang',
        'autoPlayNextEpisode',
    ];
    let filteredProfileList = [],
        currentIndex = 0,
        newResult = null,
        obj_loop_cnt = 0;
    ProfileLists.filter((item, index) =>
        Object.keys(item).reduce((result, key) => {
            if (profileKeys.includes(key)) {
                if (index !== currentIndex) {
                    filteredProfileList[currentIndex] = newResult;
                    result = {};
                    obj_loop_cnt = 0;
                }
                newResult = Object.assign(result, { [key]: item[key] });
                currentIndex = index;
                obj_loop_cnt++;
                if (index === ProfileLists.length - 1 && obj_loop_cnt === profileKeys.length) {
                    filteredProfileList[currentIndex] = newResult;
                }
            }
            return result;
        }, {})
    );
    return JSON.stringify(filteredProfileList);
};

export const getMixpanelProfileName = (ProfileName) => {
    return {
        'Profile Name': ProfileName,
    };
};
export const getMixpanelProfilesCreateSetupProps = (Profiles) => {
    return {
        Profiles: Profiles,
        'Profile Count': Profiles.length,
    };
};
export const getMixpanelProfilesCount = (ProfileCount) => {
    return {
        'Profiles Count': ProfileCount,
    };
};
export const getMixpanelProfileProperties = (profile) => {
    return {
        'Profile Name': profile.profileName,
        Protected: profile.passwordProtected,
        'Default Audio Language': profile.defaultAudioLang,
        'Default Subtitle Language': profile.defaultSubTitleLang,
        'Parental Control': profile.newParentalControl || profile.parentalControl,
        'Auto Play Next Episode': profile.autoPlayNextEpisode,
        'Kids Mode': profile.kidsMode,
        'Profile Type': profile.kidsMode ? 'Kids' : 'Normal',
    };
};
export const getMixpanelCountryNotAllowedProperties = () => {
    return { Country: h.getLocation() };
};

export const getMixpanelGlobalSearchProperties = (keyword, screen) => {
    return {
        Keyword: keyword,
        ...(screen && { 'Screen Name': screen.toUpperCase() }),
    };
};

export const getMixpanelItemPlayedProperties = (item, playerType) => {
    let mxItmPlaydProps = {};
    let itemType = {};
    if (playerType === playerTypes.LiveTV) {
        itemType = getMixpanelItemTypeProperty(item);
        mxItmPlaydProps['Item Name'] = item.title;
    } else {
        if (item.programType) {
            mxItmPlaydProps['itemType'] = ITEM_TYPE[item.programType?.toUpperCase()];
        }
        mxItmPlaydProps['Item Name'] = item.textEn;
    }
    mxItmPlaydProps = Object.assign(mxItmPlaydProps, itemType);
    return mxItmPlaydProps;
};

/**
 * VOD Item Properties for Mixpanel.
 * @param vod - VOD asset object
 * @param playbackContext - Optional. Video Quality, Video Codec, Max Height, Audio Quality from stream/player
 */
export const getMixpanelVodProperties = (vod, playbackContext) => {
    const providers = h.getProviders();
    return {
        'VOD Name': vod.name || vod.textEn || vod.text || '', // String: VOD Name in EN
        'VOD Year': Number(vod.year), // Number
        'VOD Rating': vod.ratings, // String
        ...(vod.programType && { 'VOD Type': ITEM_TYPE[vod?.programType?.toUpperCase()] }), // String [Movie, Series, Episode]
        ...(vod.genre && { 'VOD Genre': vod.genre }), // String [Featured, Action, Comerdy, Thriller, Family, Drama]
        ...(vod?.programType?.toUpperCase() === 'EPISODE' && {
            'Episode Number': Number(vod.tvSeasonEpisodeNumber || 0), // Number(Only if Type Episode)
            'Season Number': Number(vod.tvSeasonNumber || 0), // Number(Only if Type Episode)
        }),
        'VOD AssetID': vod.Id, // { Url } this will have PAID information
        ...(vod.guid && { GUID: vod.guid }), //{Unique ID from api}
        ...(vod.provider && { 'VOD Provider': vod.provider.map((i) => (providers[i] || {}).mixpanel || '')[0] }), // String [JawwyTV, Starzplay, Widekhaliji, FOX+, BluTV, Boomerang - CN etc.]
        ...(vod.categories && { 'VOD Category': vod.categories }), // List [Movies, TV Shows, Premier, Arabic, Exclusives, etc.]
        // Playback context - from stream/player when available
        ...(playbackContext?.videoQuality && {
            'Video Quality': playbackContext.videoQuality,
        }), // String: SD, HD, 4K
        ...(playbackContext?.videoCodec && {
            'Video Codec': playbackContext.videoCodec,
        }), // String: H.264, H.265
        ...(playbackContext?.maxHeight && {
            'Max Height': playbackContext.maxHeight,
        }), // String: 576p, 720p, 1080p, 2160p
        ...(playbackContext?.audioQuality && {
            'Audio Quality': playbackContext.audioQuality,
        }), // String: Stereo, Dolby
    };
};

/**
 * Linear Item Properties for Mixpanel.
 * @param item - Program/channel object
 * @param playbackContext - Optional. Video Quality, Video Codec, Max Height, Audio Quality from stream/player
 */
export const getMixpanelLinearProperties = (item, playbackContext) => {
    return {
        ...(item?.name && { 'Program Name': item.name }), // String: Program Name in EN
        ...(item?.title && { 'Program Name': item.title }), // String: Program Name in EN
        ...(item?.channelNumber && { 'Channel Number': item.channelNumber }), // Number
        ...(item?.channelName && { 'Channel Name': item.channelName }), // String: Channel Name in EN
        ...(item?.channelTitle && { 'Channel Name': item.channelTitle }), // String: Channel Name in EN
        ...(item?.channelCategory && { 'Channel Category': item.channelCategory }), // String {"Entertainment", "Religious", "Movies","News","Documentary", "Kids"}
        ...(item?.guid && { PAID: item.guid }), // {Url}
        ...(item?.paId && { PAID: item.paId }),
        ...(item?.listingId && { 'Listing ID': item.listingId }),
        // Playback context - from stream/player when available
        ...(playbackContext?.videoQuality && {
            'Video Quality': playbackContext.videoQuality,
        }), // String: SD, HD, 4K
        ...(playbackContext?.videoCodec && {
            'Video Codec': playbackContext.videoCodec,
        }), // String: H.264, H.265
        ...(playbackContext?.maxHeight && {
            'Max Height': playbackContext.maxHeight,
        }), // String: 576p, 720p, 1080p, 2160p
        ...(playbackContext?.audioQuality && {
            'Audio Quality': playbackContext.audioQuality,
        }), // String: Stereo, Dolby
    };
};

export const getMixpanelErrorCodeProperty = (errorCode) => ({ 'Error Code': errorCode });

export const getItemProperties = function (item) {
    return (item?.promoType || item?.category) === 'VOD'
        ? getMixpanelVodProperties(item)
        : getMixpanelLinearProperties(item);
};

export const getHourOfDay = () => {
    return new Date().getHours();
};
export const getDayOfWeek = () => {
    return new Date().toLocaleString('en-US', {
        weekday: 'long',
    });
};
export const getCurrentDate = () => {
    return new Date();
};

// This config has been moved, should be removed after testing...
export const MapGamificationRewardProperties = {
    tier_upgrade: EVENT.GAMIFICATION.SUBSCRIPTION_UPGRADE_CHOSEN,
    tvod_rent: EVENT.GAMIFICATION.TVOD_RENT,
    renew_subscription: EVENT.GAMIFICATION.SUBSCRIPTION_UPGRADE_CHOSEN,
    tvod_purchased: EVENT.GAMIFICATION.TVOD_RENT,
    vod_watched: EVENT.GAMIFICATION.MOVIES_AND_SHOWS,
    watch_live_tv: EVENT.GAMIFICATION.LIVE_TV,
};
